// window.fetch polyfill
import 'whatwg-fetch'
import _ from 'lodash'
import * as uuid from 'uuid'

// Get the appId from localStorage.
let appId = JSON.parse(window.localStorage.getItem('appId') || 'null')
// Generate and persist a new one?
if (appId === null) {
  appId = uuid()
  window.localStorage.setItem('appId', JSON.stringify(appId))
}
// Set the cookie.
document.cookie = 'appId=' + appId + ';path=/'

// window.Promise polyfill
require('es6-promise').polyfill()

let handleError = statusCode => { }

export const ERR_INVALID_APIRESULT = 'ERR_INVALID_APIRESULT'

export const getJson = function ({ url }) {
  return new Promise((resolve, reject) => {
    window.fetch(url, {
      credentials: 'same-origin'
    }).then(response => {
      // Always parse response
      return response.json()
    }).then(data => {
      if (data === null) {
        resolve(null)
      }
      if (isApiResult(data)) {
        if (data.Success) {
          resolve(data.Data)
        } else {
          resolve(data.Error)
        }
      } else {
        resolve(data)
      }
    }).catch(exception => {
      reject()
    })
  })
}

// The same as getJson api call but this call will just return an apiResult if it is one.
export const getJsonApiResult = function ({ url }) {
  return new Promise((resolve, reject) => {
    window.fetch(url, {
      credentials: 'same-origin'
    }).then(response => {
      // Always parse response
      return response.json()
    }).then(data => {
      if (data === null) {
        resolve(null)
      }
      if (isApiResult(data)) {
        resolve(data)
      } else {
        reject(new Error('No apiresult was returned.'))
      }
    }).catch(exception => {
      reject()
    })
  })
}

export const postJson = function ({ url, data }) {
  return new Promise((resolve, reject) => {
    window.fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    }).then(response => {
      if (response.redirected) {
        window.location = response.url
      }
      // Always parse response
      return response.json()
    }).then(data => {
      if (data === null) {
        resolve(null)
      }
      if (isApiResult(data)) {
        if (data.Success) {
          resolve(data.Data)
        } else {
          resolve(data.Error)
        }
      } else {
        resolve(data)
      }
    }).catch(exception => {
      reject(exception)
    })
  })
}

export const putJson = function ({ url, data }) {
  return new Promise((resolve, reject) => {
    window.fetch(url, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    }).then(response => {
      // Always parse response
      return response.json()
    }).then(data => {
      if (data === null) {
        resolve(null)
      }
      if (isApiResult(data)) {
        if (data.Success) {
          resolve(data.Data)
        } else {
          resolve(data.Error)
        }
      } else {
        resolve(data)
      }
    }).catch(exception => {
      reject()
    })
  })
}

export const deleteJson = function ({ url, data }) {
  return new Promise((resolve, reject) => {
    window.fetch(url, {
      method: 'delete',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    }).then(response => {
      // Always parse response
      return response.json()
    }).then(data => {
      if (data === null) {
        resolve(null)
      }
      if (isApiResult(data)) {
        if (data.Success) {
          resolve(data.Data)
        } else {
          resolve(data.Error)
        }
      } else {
        resolve(data)
      }
    }).catch(exception => {
      reject()
    })
  })
}

export const postFormData = function ({ url, data }) {
  return new Promise((resolve, reject) => {
    // Create formData
    let formData = new window.FormData()
    formData.append('file', data)
    // Call the url and post formData
    window.fetch(url, {
      method: 'post',
      // Don't set headers { 'Content-Type' }
      body: formData,
      credentials: 'same-origin'
    }).then(response => {
      // Always parse response
      return response.json()
    }).then(data => {
      if (data === null) {
        resolve(null)
      }
      if (isApiResult(data)) {
        if (data.Success) {
          resolve(data.Data)
        } else {
          resolve(data.Error)
        }
      } else {
        resolve(data)
      }
    }).catch(exception => {
      reject()
    })
  })
}

export const openUrl = function ({ url }) {
  return new Promise((resolve, reject) => {
    window.open(url, {
      credentials: 'same-origin'
    })
  })
}

export const openPostUrl = function ({ url, data }) {
  return new Promise((resolve, reject) => {
    window.open(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    })
  })
}

export const chunkUpload = function ({ url, file, metadata, reload, callback }) {
  // Get the filename.
  const fileName = file.name
  // Generate an upload id.
  const uploadId = _.now() + '-' + uuid.v4()
  // Create a method to prepare the chunk's body.
  const createFormData = function (chunkData) {
    // Create formData
    const result = new window.FormData()
    // Add the blob.
    result.append('file', chunkData, fileName)
    // Add the reload propery?
    result.append('Reload', reload || false)
    // Set up metadata.
    _.forEach(metadata, function (value, key) {
      if (value instanceof Array) {
        let tempValue = ''
        _.forEach(value, function (element) { tempValue += element + ';' })
        // Remove the last ;
        tempValue = tempValue.slice(0, -1)
        result.append(key, tempValue)
      } else {
        result.append(key, value)
      }
    })
    return result
  }
  // Create the promise.
  return new Promise((resolve, reject) => {
    // Determine chunk size and total size.
    const chunkSize = 5242500 // 5MB
    const totalSize = file.size
    let percentDone = 0
    // Determine the amount of chunks.
    let chunkCount = window.Math.floor(totalSize / chunkSize)
    if ((totalSize % chunkSize) > 0) {
      chunkCount += 1
    }
    let chunkIndex = 0
    // Setup the chunk procesor.
    let processChunk = function () {
      // Get the offset of the current chunk
      const chunkOffset = (chunkIndex * chunkSize)
      const nextChunkOffset = window.Math.min((chunkOffset + chunkSize), totalSize)
      // Read the current slice.
      const chunkData = file.slice(chunkOffset, nextChunkOffset)
      // Get the formdata
      const formData = createFormData(chunkData)
      // Setup the headers.
      const headers = new window.Headers({
        'Content-Range': 'bytes ' + chunkOffset + '-' + (nextChunkOffset - 1) + '/' + totalSize,
        'X-DS-Identifier': uploadId
      })
      // Upload the chunk.
      // Call the url and post formData
      window.fetch(url, {
        method: 'post',
        headers: headers,
        body: formData,
        credentials: 'same-origin'
      }).then(response => {
        // Check if the response was ok.
        if (response.ok) {
          // Up the chunk counter.
          chunkIndex++
          percentDone = ((chunkIndex * chunkSize) / totalSize) * 100
          callback(percentDone)
          // More chunks available?
          if (chunkIndex < chunkCount) {
            // Upload the next chunk.
            processChunk()
          } else {
            response.json().then(data => {
              // Done.
              resolve(data)
            })
          }
        } else {
          // Parse the response and reject the message
          response.json().then(data => {
            reject(data)
          })
        }
      }).catch(exception => {
        reject(exception)
      })
    }
    // Start processing
    processChunk()
  })
}

export const isApiResult = function (input) {
  return (
    input &&
    input.hasOwnProperty('Success') &&
    input.hasOwnProperty('Data') &&
    input.hasOwnProperty('Error'))
}
export const getFile = function ({ url }) {
  return new Promise((resolve, reject) => {
    window.fetch(url, {
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-AppId': appId
      }
    }).then(response => {
      // Check if the response was ok.
      if (response.ok) {
        // Parse as json.
        return response.blob()
      } else {
        // Request failed.
        return response.blob()
      }
    }).then(data => {
      // Done
      resolve(data)
    }).catch(exception => {
      handleError(exception.statusCode)
      reject(exception)
    })
  })
}

export const postFile = function ({ url, fileName, fileStream, privilegizedEntityId }) {
  return new Promise((resolve, reject) => {
    // Create a request.
    let request = getXMLHttpRequest('POST', url)
    let data = new window.FormData()
    // Prepare the data.
    data.append('file', fileStream, fileName)
    data.append('privId', privilegizedEntityId)
    request.onreadystatechange = function (oEvent) {
      if (request.readyState === 4) {
        if (request.status === 200) {
          // Parse result.
          let result = String

          if (request.response && request.response !== '') {
            result = JSON.parse(request.response)
          }

          // Get response data.
          if (result) {
            resolve(result)
          } else {
            reject(oEvent)
          }
        } else {
          reject(oEvent)
        }
      }
    }

    // Create and send the form.
    request.send(data)
  })
}
export const getXMLHttpRequest = function (method, uri) {
  // Create a request.
  let request = new window.XMLHttpRequest()
  // Open the request.
  request.open(method, uri, true)
  // Set required headers.
  request.setRequestHeader('X-AppId', appId)
  // Return the request.
  return request
}



// WEBPACK FOOTER //
// ./src/api/baseApi.js